import BigNumber from 'bignumber.js'

import { BigNumber as BigNumber_, Order } from '@blade/std-lib'
import { CurrencyModel } from '@root/entities/currency'
import { PairAddress } from '@root/entities/pair'
import { Trend } from '@root/entities/trend'

import type { Network } from '@root/entities/network'
import type { UserProfileHoldingsWalletAssetDto } from '@root/shared/api/UserApi'
import type { TokenLogosHost } from '@root/shared/models'

export interface UserProfileHoldingsWalletAsset {
  currency: CurrencyModel
  pairAddress?: PairAddress
  name: string
  ticker: string
  balance: BigNumber
  decimals: BigNumber
  priceUsd: BigNumber
  priceNative: BigNumber

  balanceUsd: BigNumber
  balanceNative: BigNumber
}

export const fromDto = (
  dto: UserProfileHoldingsWalletAssetDto,
  options: {
    network: Network.Network
    tokenLogosHost: TokenLogosHost
  },
): UserProfileHoldingsWalletAsset => {
  const currency = CurrencyModel.fromWalletAssetDto(
    {
      address: dto.address,
      balance: dto.balance,
      decimals: dto.decimals,
      name: dto.name,
      symbol: dto.symbol,
      priceUsd: dto.priceUsd,
      priceNative: dto.priceNative,
      logo: dto.logo,
      logoStatus: dto.logoStatus,
      trend: Trend.Neutral,
      hidden: false,
    },
    options.tokenLogosHost,
    options.network,
  )
  const balance = BigNumber(dto.balance)
  const priceUsd = BigNumber(dto.priceUsd)
  const priceNative = BigNumber(dto.priceNative)

  return {
    currency,
    balance,
    balanceUsd: balance.multipliedBy(priceUsd),
    balanceNative: balance.multipliedBy(priceNative),
    decimals: BigNumber(dto.decimals),
    priceUsd,
    priceNative,
    pairAddress: dto.pairAddress ? PairAddress(dto.pairAddress) : undefined,
    name: dto.name,
    ticker: dto.symbol,
  }
}

export const cmpByBalanceUsdAsc = Order.mapInput(
  BigNumber_.order,
  (x: UserProfileHoldingsWalletAsset) => x.balanceUsd,
)
export const cmpByBalanceUsdDesc = Order.flip(cmpByBalanceUsdAsc)
